export const typZpusobPorizeniSelect = [
    {
        value: 'R',
        labelcz: 'SS_DETAIL_TAB_PORIZENI_R'
    },
    {
        value: 'D',
        labelcz: 'SS_DETAIL_TAB_PORIZENI_D'
    }
    /*  {
        value: 'CDCP',
        labelcz: 'SS_DETAIL_TAB_PORIZENI_CDCP'
    } */
];
